import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "../app/store";

import { LANGUAGE_CONFIG } from "../assets/i18n";

import * as locales from "@mui/material/locale";
export type SupportedLocales = keyof typeof locales;

export interface HomeState {
  currentLanguage: SupportedLocales;
}

// 使用语言配置中的默认语言映射
const DEFAULT_REDUX_LANGUAGE = LANGUAGE_CONFIG.LANGUAGE_MAP[LANGUAGE_CONFIG.DEFAULT_LANGUAGE as keyof typeof LANGUAGE_CONFIG.LANGUAGE_MAP] as SupportedLocales;

const initialState: HomeState = {
  currentLanguage: DEFAULT_REDUX_LANGUAGE,
};

export const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    updateCurrentLanguage: (state, action: PayloadAction<SupportedLocales>) => {
      state.currentLanguage = action.payload;
    },
  },
  extraReducers: (builder) => {},
});

export const { updateCurrentLanguage } = homeSlice.actions;

export const selectCurrentLanguage = (state: RootState) => state.home.currentLanguage;

export default homeSlice.reducer;
